import React, { useEffect, useRef, useState } from "react";

import { useAddQuizMutation } from "../../features/quizzes/quizzesApi";
import { useGetVideosQuery } from "../../features/videos/videosApi";
import Error from "../ui/Error";
import Success from "../ui/Success";
import styles from "./quizForm.module.css";

export default function QuizAddForm() {
  const questionRef = useRef();

  const [isQuizAdded, setIsQuizAdded] = useState(false);
  const [isCorrectOptionChoosed, setIsCorrectOptionChoosed] = useState(true);

  const chooseVideoRef = useRef();

  const option1Ref = useRef();
  const option1CheckRef = useRef();

  const option2Ref = useRef();
  const option2CheckRef = useRef();

  const option3Ref = useRef();
  const option3CheckRef = useRef();

  const option4Ref = useRef();
  const option4CheckRef = useRef();

  const { data: videos } = useGetVideosQuery();
  const [addQuiz, { isLoading, isSuccess: isAddQuizSuccess }] =
    useAddQuizMutation();

  const clearForm = () => {
    // set the value of all the inputs
    questionRef.current.value = "";
    chooseVideoRef.current.value = 1;
    option1Ref.current.value = "";
    option2Ref.current.value = "";
    option3Ref.current.value = "";
    option4Ref.current.value = "";
    option1CheckRef.current.checked = false;
    option2CheckRef.current.checked = false;
    option3CheckRef.current.checked = false;
    option4CheckRef.current.checked = false;
  };

  const handleAddQuiz = (e) => {
    e.preventDefault();

    const videoTitle = videos?.find(
      (video) => video.id === Number(chooseVideoRef.current.value)
    ).title;
    const data = {
      question: questionRef?.current.value,
      video_id: Number(chooseVideoRef.current.value),
      video_title: videoTitle,
      options: [
        {
          id: 1,
          option: option1Ref?.current.value,
          isCorrect: option1CheckRef.current.checked,
        },
        {
          id: 2,
          option: option2Ref?.current.value,
          isCorrect: option2CheckRef.current.checked,
        },
        {
          id: 3,
          option: option3Ref?.current.value,
          isCorrect: option3CheckRef.current.checked,
        },
        {
          id: 4,
          option: option4Ref?.current.value,
          isCorrect: option4CheckRef.current.checked,
        },
      ],
    };
    if (
      option1CheckRef.current.checked ||
      option2CheckRef.current.checked ||
      option3CheckRef.current.checked ||
      option4CheckRef.current.checked
    ) {
      addQuiz(data);
      setIsCorrectOptionChoosed(true);
    } else {
      setIsCorrectOptionChoosed(false);
    }
  };

  useEffect(() => {
    if (isAddQuizSuccess) {
      clearForm();
      setIsQuizAdded(true);
    }
  }, [setIsQuizAdded, isAddQuizSuccess]);

  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        <form
          onSubmit={handleAddQuiz}
          className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
        >
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="questionInput">Question</label>
            <input
              onChange={() => setIsQuizAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="questionInput"
              ref={questionRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="chooseVideoSelect">Choose video</label>
            <select
              required
              onChange={() => setIsQuizAdded(false)}
              ref={chooseVideoRef}
              id="chooseVideoSelect"
              className="bg-slate-900 p-2 "
              defaultValue={1}
            >
              {videos?.map((video) => (
                <option value={video.id} key={video.id}>
                  {video.title}
                </option>
              ))}
            </select>
          </div>

          <div className="formGroup flex items-center justify-between">
            <label
              htmlFor="option1Input"
              className="flex items-center gap-2"
              style={{ whiteSpace: "noWrap" }}
            >
              <input
                onChange={() => setIsQuizAdded(false)}
                ref={option1CheckRef}
                className="cursor-pointer"
                type="checkbox"
                title="Is this option is correct"
              />
              Option 1
            </label>
            <input
              onChange={() => setIsQuizAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="option1Input"
              ref={option1Ref}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label
              htmlFor="option2Input"
              className="flex items-center gap-2"
              style={{ whiteSpace: "noWrap" }}
            >
              <input
                onChange={() => setIsQuizAdded(false)}
                ref={option2CheckRef}
                className="cursor-pointer"
                type="checkbox"
                title="Is this option is correct"
              />
              Option 2
            </label>
            <input
              onChange={() => setIsQuizAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="option2Input"
              ref={option2Ref}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label
              htmlFor="option3Input"
              className="flex items-center gap-2"
              style={{ whiteSpace: "noWrap" }}
            >
              <input
                onChange={() => setIsQuizAdded(false)}
                ref={option3CheckRef}
                className="cursor-pointer"
                type="checkbox"
                title="Is this option is correct"
              />
              Option 3
            </label>
            <input
              onChange={() => setIsQuizAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="option3Input"
              ref={option3Ref}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label
              htmlFor="option4Input"
              className="flex items-center gap-2"
              style={{ whiteSpace: "noWrap" }}
            >
              <input
                onChange={() => setIsQuizAdded(false)}
                ref={option4CheckRef}
                className="cursor-pointer"
                type="checkbox"
                title="Is this option is correct"
              />
              Option 4
            </label>
            <input
              onChange={() => setIsQuizAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="option4Input"
              ref={option4Ref}
            />
          </div>

          {isQuizAdded && <Success message={"Quiz added successfully"} />}
          {!isCorrectOptionChoosed && (
            <Error message={"Please choose at least one correct option!"} />
          )}
          <button
            disabled={isLoading}
            type="submit"
            className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
          >
            Add
          </button>
        </form>
      </div>
    </>
  );
}
